<template>
	<v-layout row wrap fill-height class="parts">
		<v-flex xs12 md3>
			<v-card>
				<v-list class="py-0 admin__sidebar-menu" dark>
					<v-list-tile ripple to="/admin/products/import" avatar class="secondary">
						<v-list-tile-avatar>
							<div class="v-icon secondary theme--dark">
								<fa-icon :icon="['far', 'upload']" size="xs" />
							</div>
						</v-list-tile-avatar>

						<v-list-tile-content>
							<v-list-tile-title>Import Products</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>

				<v-list subheader v-for="partFamily in partFamilies" :key="partFamily.id" v-show="false">
					<v-subheader>{{ partFamily.name }}</v-subheader>
					<!-- <v-list-group v-for="partType in partTypes">
						{{partType}}
						<v-list-tile slot="activator">
							<v-list-tile-content>
								<v-list-tile-title>
									<span class="decision-tree__step-title">{{partType.name}}</span>
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>

						<v-list-tile v-for="item in partTypes" :key="item.type" @click="addType(item.type)">
							<v-list-tile-content>
								<v-list-tile-title>{{ item.type }}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>-->
				</v-list>

				<!-- <v-list class="py-0">
					<v-list-tile v-for="part in PARTS" :key="part.id" :to="`/admin/parts/${part.id}`">{{part.name}}</v-list-tile>
				</v-list>-->
			</v-card>
		</v-flex>

		<v-flex xs12 md9>
			<router-view :key="$route.fullPath"></router-view>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
	data() {
		return {
			part_family_active: false,
			part_type_active: false,
			part_family: null,
			part_type: null
		};
	},

	props: {
		slug: {
			default: null
		}
	},

	computed: {
		...mapGetters("quote-builder", ["parts"]),

		// ...mapGetters("quote-builder", {
		// 	PARTS: "parts"
		// }),

		partFamilies() {
			return _.uniqBy(_.map(this.parts, "part_family"), "id");
		},

		partTypes() {
			// return this.parts;
			// return _.uniq(_.map(this.parts, "type"), "type");
			// if (!this.part_family) {
			// 	return false;
			// }
			// return _.uniqBy(
			// 	_.filter(this.parts, { part_family_id: this.part_family.id }),
			// 	"type"
			// );
		},

		partFamilyGroups() {
			let partFamilyGroups = [];

			return _.uniqBy(_.map(this.parts, "part_family"), "id");
		}
	},

	methods: {
		...mapActions("quote-builder", {
			GET_PARTS: "getParts"
		})
	},

	created() {
		this.GET_PARTS();
	}
};
</script>
